export const ADD_EDIT_FOURNISSEURS = {
  title: {
    add: 'Nouveau fournisseur',
    edit: 'Modifier le fournisseur',
  },
  notifications: {
    successCreation: 'Création du fournisseur réalisée avec succès.',
    successChange: 'Modification du fournisseur réalisée avec succès.',
  },
  breadcrumb: {
    liste: 'Liste des fournisseurs',
    add: 'Nouveau fournisseur',
    edit: 'Modifier un fournisseur',
  },
  tabs: {
    informationsTab: 'Informations',
    competencesTab: 'Compétences',
  },
  informationsGenerales: {
    title: 'Informations générales',
    code: 'Code',
    nomCommercial: 'Raison sociale',
    nomService: 'Nom du service',
    siret: 'Siret',
    apeNaf: 'APE/NAF',
    tvaIntracommunautaire: 'TVA intracommunautaire',
    role: 'Rôle',
    applicationTva: 'Application de la TVA',
    interne: 'Interne',
    numeroCedant: 'Numéro de cédant',
    numeroFichier: 'Numéro de fichier de transfert',
  },
  adresse: {
    title: 'Adresse',
    postalAddress: 'Adresse postale',
    addressBillingDifferent: 'Adresse de facturation différente de l\'adresse postale.',
  },
  coordonee: {
    title: 'Coordonnées',
    telephone: 'Téléphone',
    telephonePortable: 'Téléphone portable',
    email: 'Email',
    siteInternet: 'Site internet',
  },
  contact: {
    title: 'Contacts',
  },
  infoComptable: {
    title: 'Informations comptables',
    compteComptable: 'Compte comptable',
  },
  commentaire: {
    title: 'Commentaire',
    commentaire: 'Commentaire',
    commentairesFactor: 'Commentaires factor',
  },
  piecesJointes: {
    title: 'Pièces jointes',
  },
  competences: {
    title: 'Compétences',
    addCompetence: 'Ajouter une compétence',
    table: {
      libelle: 'Libelle',
    },
    popupAdd: {
      title: 'Ajouter une compétence',
      competenceFournisseur: 'Compétence du fournisseur',
    },
  },
  errors: {
    roleRequired: 'Le rôle est obligatoire.',
  },
};

export const DETAIL_FOURNISSEURS = {
  title: 'Détail {libelle}',
  breadcrumb: {
    liste: 'Liste des fournisseurs',
    detail: 'Détail fournisseur {libelle}',
    detailService: 'Détail service {libelle}',
  },
  tabs: {
    informationsTab: 'Informations',
    competencesTab: 'Compétences',
    enCoursFournisseursTab: 'Encours fournisseur',
    compteFournisseurTab: 'Compte fournisseur',
  },
  steps: {
    infoGenerales: 'Informations générales',
    contacts: 'Contacts',
    infoComptables: 'Informations comptables',
    commentaires: 'Commentaires',
    piecesJointes: 'Pièces jointes',
  },
  informationsGenerales: {
    title: 'Informations générales',
  },
  contacts: {
    title: 'Contacts',
  },
  infoComptables: {
    title: 'Informations comptables',
  },
  commentaires: {
    title: 'Commentaires',
    titleFactor: 'Commentaires factor',
  },
  piecesJointes: {
    title: 'Pièces jointes',
  },
  infoCompta: {
    title: 'Informations comptables',
    compteComptable: 'Compte comptable',
  },
};

export const LISTE_FOURNISSEURS = {
  fournisseurs: 'Fournisseurs',
  title: 'Liste des fournisseurs',
  breadcrumb: {
    liste: 'Liste des fournisseurs',
  },
  actions: {
    add: 'Nouveau fournisseur',
  },
  tab: {
    code: 'Code',
    sousTypes: 'Rôle du fournisseur',
    interne: 'Interne',
    nomCommercial: 'Raison sociale',
    adresse: 'Adresse',
    codePostal: 'Code postal',
    ville: 'Ville',
    telephone: 'Téléphone',
    portable: 'Portable',
    email: 'Email',
    compteComptable: 'Compte comptable',
  },
  filtre: {
    fournisseurs: 'Fournisseurs',
    sousTypes: 'Rôle du fournisseur',
    archive: 'Archivé',
    competenceFournisseurs: 'Compétences fournisseur',
  },
  archivage: {
    titleDesarchiver: 'Etes-vous sûr de vouloir désarchiver ce fournisseur ?',
    title: 'Etes-vous sûr de vouloir archiver ce fournisseur ?',
    successArchivage: 'Fournisseur archivé avec succès.',
    successDesarchivage: 'Fournisseur désarchivé avec succès.',
  },
};
